<template>
  <div v-if="hasVisibleFields"
       class="mobile-registration-form__practice-type-container">
    <fieldset v-show="formFields.practiceSetting && !formFields.practiceSetting.isHidden"
              id="mobilePracticeSettingField"
              class="wk-js2 mobile-registration-form-field">
      <UtdSelect id="mobilePracticeSettingSelect"
                 :selected="form.practiceSetting"
                 :options="practiceSettingOptions"
                 label="Practice Setting"
                 required
                 placeholder="Select your practice setting"
                 :use-index="false"
                 @input="emit('selectChange', { value: $event, name: REG_FIELD.PRACTICE_SETTING })"
      />
    </fieldset>
    <fieldset v-show="formFields.practiceType && !formFields.practiceType.isHidden"
              id="mobilePracticeTypeField"
              class="wk-js2 mobile-registration-form-field">
      <UtdSelect id="mobileRoleSelect"
                 :selected="form.practiceType"
                 :options="roleOptions"
                 label="Role"
                 required
                 placeholder="Select your role"
                 :use-index="false"
                 @input="emit('selectChange', { value: $event, name: REG_FIELD.PRACTICE_TYPE })"
      />
    </fieldset>
    <fieldset v-show="formFields.specialty && !formFields.specialty.isHidden"
              id="mobileSpecialtyField"
              class="wk-js2 mobile-registration-form-field">
      <UtdSelect id="mobileSpecialtySelect"
                 :selected="form.specialty"
                 :options="specialtyOptions"
                 label="Specialty"
                 required
                 placeholder="Select your specialty"
                 :use-index="false"
                 @input="emit('selectChange', { value: $event, name: REG_FIELD.SPECIALTY })"
      />
    </fieldset>
  </div>
</template>

<script setup>
import UtdSelect from '_acaSrc/components/shared/input/UtdSelect.vue';
import useRegistrationForm from '_acaSrc/composables/registrationForm.composable';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { REG_FIELD } from '_acaSrc/utility/constants';

const store = useStore();

const practiceSettingOptions = computed(() =>
    store.getters['account/myAccountPracticeSettingOptions']);
const roleOptions = computed(() => store.getters['account/myAccountpracticeTypeOptions']);
const specialtyOptions = computed(() => store.getters['account/myAccountSpecialtyOptions']);

const registrationForm = computed(() => store.getters['login/registrationForm']);
const formFields = computed(() => registrationForm.value.formFields);

const hasVisibleFields = computed(() =>
    (formFields.value.practiceSetting && !formFields.value.practiceSetting.isHidden)
    || (formFields.value.practiceType && !formFields.value.practiceType.isHidden)
    || (formFields.value.specialty && !formFields.value.specialty.isHidden));

const emit = defineEmits([ 'selectChange' ]);

const { form } = useRegistrationForm();
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.mobile-registration-form__practice-type-container {
  .ds1-pa-2();
  .ds1-mb-3();
  background-color: @DS2-UTD-SELECT-CONTAINER-BG-COLOR;
  border: @DS2-UTD-FOOTER-DIVIDER-BORDER-COLOR;
}

.xAIMobile {
  .mobile-registration-form__practice-type-container {
    background-color: @WKCE-CREAM-TINT2;
    border: none;

    :deep(.wk-select__input) {
      background-color: @WKCE-WHITE;
      border-radius: 50px;
      border: 1px solid @WKCE-CREAM;
    }

    :deep(.wk-field-label) {
      color: @WKCE-CREAM-SHADE2;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>

